import Vue from "vue";
import Vuex from "vuex";
import cows from "./modules/cows";
import states from "./modules/states";
import alerts from "./modules/alerts";
import technicalStatuses from "./modules/technical-statuses";
import events from "./modules/events";
import boluses from "./modules/boluses";
import buildings from "./modules/buildings";
import chart from "./modules/chart";
import sensorLogs from "./modules/sensor-logs";
import reports from "./modules/reports";
import thiSensors from "./modules/thi-sensors";
import createPersistedState from "vuex-persistedstate";
import UsersService from "../../services/UsersService";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    chart,
    cows,
    states,
    alerts,
    events,
    boluses,
    buildings,
    sensorLogs,
    reports,
    thiSensors,
    technicalStatuses
  },
  plugins: [
    createPersistedState({
      paths: [
        "user",
        "token",
        "isUserLoggedIn",
        "locale",
        // For neighbours to work after reload
        "cows.cowList"
      ]
    })
  ],
  state: {
    token: null,
    user: {},
    isUserLoggedIn: false,

    locale: "en",
    timeZone: null
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
      state.isUserLoggedIn = !!token;
    },
    setUser(state, user) {
      state.user = user || {};
    },
    setLocale(state, locale) {
      state.locale = locale;
    },
    setTimeZone(state, timeZone) {
      state.timeZone = timeZone;
    },
    setUserCelsius(state, celsius){
      state.user.celsius = celsius;
    }
  },
  actions: {
    setToken({ commit }, token) {
      commit("setToken", token);
    },
    setUser({ commit }, user) {
      commit("setUser", user);
    },
    setLocale({ commit }, locale) {
      commit("setLocale", locale);
    },
    setTimeZone({ commit }, timeZone) {
      commit("setTimeZone", timeZone);
    },
    async fetchAndSetUserCelsius({commit, state}){
      try{
        if (!state.token) return;

        const decodedToken = JSON.parse(atob(state.token.split('.')[1]));

        if (!decodedToken) return;

        const userID = decodedToken.userID;
        const response = await UsersService.show(userID)

        commit('setUserCelsius', response.data.celsius);
      } catch (error) {
        commit('setUserCelsius', true);
      }
    },
    clearAll({ commit }) {
      this.dispatch("chart/clear");
      this.dispatch("cows/clear");
      this.dispatch("states/clear");
      this.dispatch("alerts/clear");
      this.dispatch("boluses/clear");
      this.dispatch("buildings/clear");
      this.dispatch("sensorLogs/clearSensorLogs");
      this.dispatch("sensorLogs/clearDebugSensorLogs");
      this.dispatch("sensorLogs/clearThiSensorLogs");
      this.dispatch("thiSensors/clear");
    }
  }
});



// WEBPACK FOOTER //
// ./src/plugins/store/store.js